import React, { useState, useRef, useEffect } from 'react';
import { cfLogo } from '../../assets'
import { BsCaretDownFill, BsCloudLightningFill } from 'react-icons/bs';
import { RiSettings4Line, RiLogoutCircleLine } from "react-icons/ri"
import { NavLink } from 'react-router-dom';
import { deleteCookie } from '../../helper';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase'
import {
  BellAlertIcon,
  TrashIcon,
  EyeIcon,
} from "@heroicons/react/24/outline";
import SeeAllNotification from './SeeAllNotification';
import { SelectNotification, clear_all_notification } from '../../layout/Chatbot/chatabotSlice'
import { useDispatch, useSelector } from 'react-redux';
import { selectLogInUsername, setLogInUser,SelectUserEmail } from '../authenticateDashboard/authSlice';
import { resetUniqueBnDevData,resetAuthSlice,resetChatBot,resetCouponWiseData,resetEmailSlice,resetFirstlastSlice,resetpersonaSlice,resetTrafficSlice,resetTrafficSource,resetUtmCampaign,resetutmContent,resetutmMedium,resetutmOverall,resetUtmSource,resetutmTerm,resetuniqueBooking,resetuniqueBoughtSlice,resetsessionDist,resetfacebookData } from './resetReducers';

const Header = () => {
  // const user = useSelector(selectLogInUsername);
  const email = useSelector(SelectUserEmail);

  return (
    <nav className='header bg-color bg-text py-3 px-4 sticky top-0 z-20 border-b border-neutral-500 '>
      <div className="header__container flex justify-between items-center flex-wrap">
        <div className="container__logo sm:!mx-0 mx-auto">
          <img
            className="mx-auto w-48 sm:w-64 md:w-80"
            src={cfLogo}
            alt="logo" />
        </div>
        <div className="container__menu sm:!mx-0 mx-auto">
          <RightMenu>
            <DropDownMenu icon={<BsCaretDownFill />} label={email ?? 'loading...'} />
          </RightMenu>
        </div>
      </div>
    </nav>
  )
}

function RightMenu({ children }) {
  return (
    <div className="rightmenu__container">{children}</div>
  )
}

function DropDownMenu({ icon, label }) {

  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false);
  const [openNotification, setOpenNotification] = useState(false)
  const adminNotifications = useSelector(SelectNotification)
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  function handleToggleDropDown() {
    setOpen(!open);
  }

  function handleLogout(){
    deleteCookie('user');
    signOut(auth);
    dispatch(resetAuthSlice());
    dispatch(resetChatBot());
    dispatch(resetCouponWiseData());
    dispatch(resetEmailSlice());
    dispatch(resetFirstlastSlice());
    dispatch(resetpersonaSlice());
    dispatch(resetTrafficSlice());
    dispatch(resetTrafficSource());
    dispatch(resetUtmCampaign());
    dispatch(resetutmContent());
    dispatch(resetutmMedium());
    dispatch(resetutmOverall());
    dispatch(resetUtmSource());
    dispatch(resetutmTerm());
    dispatch(resetuniqueBooking());
    dispatch(resetuniqueBoughtSlice());
    dispatch(resetsessionDist());
    dispatch(resetUniqueBnDevData());
    dispatch(resetfacebookData());
    dispatch(setLogInUser(null));
  }

  function handleNotification(action = "") {
    if (action === 'see_all') {
      setOpenNotification(prev => !prev)
    } else if (action === 'clear_all') {
      dispatch(clear_all_notification())
    }
  }


  return (
    <div className="dropdown__container bg-text" ref={dropdownRef}>
      <div className="dropdown__label flex items-center gap-2 cursor-pointer select-none" onClick={handleToggleDropDown}>
        <div className='flex gap-1 items-center'>
        <span className="dropdown__label--text">{label}</span>
         {/* {adminNotifications?.length ? (<span className='text-white bg-red-500 rounded-full p-1 px-2'>{adminNotifications.length}</span>):null}  */}
        </div>
        <span className={`dropdown__label--icon transition-all duration-500 ${open && '-rotate-180'}`}>{icon}</span>
      </div>
      <div className={`dropdown__menu absolute right-6 top-24 border border-gray rounded ${open ? 'block' : 'hidden'}`}>
        {/* <SeeAllNotification open={openNotification} setOpen={setOpenNotification} NotificationObj={adminNotifications} /> */}
        <ul className="dropdown__menu--list py-4 bg-[#172b4d] dark:bg-neutral-800 rounded text-neutral-200">
          <MenuItem icon={<RiSettings4Line />} label='Settings' link="/settings" />

          {/* <button  className="block dropdown__menu--item cursor-pointer py-1 px-8 hover:bg-[#213c6c] hover:dark:bg-[#213c6c]" >
            <div className="flex items-center gap-2 ">
              <span className="dropdown__menu--item-icon scale-150">< BellAlertIcon className='text-white w-5 h-4'/></span>
              <span className="dropdown__menu--item-label"> Notification({adminNotifications.length})</span>
            </div>
            <div className='flex flex-col gap-1 pl-5'>
            <div className="flex items-center gap-2 cursor-pointer hover:font-bold" onClick={() => handleNotification('see_all')}>
              <span className="dropdown__menu--item-icon scale-150">< EyeIcon className='text-white w-4 h-3'/></span>
              <span className="dropdown__menu--item-label">See All</span>
              </div>
            <div className="flex items-center gap-2 cursor-pointer hover:font-bold " onClick={()=>handleNotification('clear_all')}>
              <span className="dropdown__menu--item-icon scale-150">< TrashIcon className='text-white w-4 h-3'/></span>
              <span className="dropdown__menu--item-label">Clear All</span>
              </div>
            
              </div>
          </button> */}
          <button onClick={handleLogout} className="dropdown__menu--item cursor-pointer py-1 px-8 hover:bg-[#213c6c] hover:dark:bg-[#213c6c]" >
            <div className="flex items-center gap-2">
              <span className="dropdown__menu--item-icon scale-150"><RiLogoutCircleLine /></span>
              <span className="dropdown__menu--item-label">Logout</span>
            </div>
          </button>
        </ul>
      </div>
    </div>
  )
}

function MenuItem({ icon, label, link }) {
  return (
    <NavLink className="dropdown__menu--item cursor-pointer block py-1 px-8 hover:bg-[#213c6c] hover:dark:bg-[#213c6c] " to={link}>
      <div className="flex items-center gap-2">
        <span className="dropdown__menu--item-icon scale-150">{icon}</span>
        <span className="dropdown__menu--item-label">{label}</span>
      </div>
    </NavLink>
  )
}

export default Header